export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";